export default "__VITE_ASSET__ZSWEpQOA__"